const AVATAR_PALETTES = [
  ['#0ea5e9', '#2563eb'],
  ['#06b6d4', '#0ea5e9'],
  ['#10b981', '#059669'],
  ['#22c55e', '#16a34a'],
  ['#f59e0b', '#ea580c'],
  ['#f97316', '#ef4444'],
  ['#ec4899', '#db2777'],
  ['#8b5cf6', '#6366f1'],
  ['#14b8a6', '#0f766e'],
  ['#64748b', '#475569']
]

function hashSeed (value) {
  const text = String(value || 'user')
  let hash = 2166136261
  for (let i = 0; i < text.length; i++) {
    hash ^= text.charCodeAt(i)
    hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24)
  }
  return hash >>> 0
}

export function avatarInitial (name) {
  const text = String(name || '').trim()
  if (!text) return 'U'
  return text.slice(0, 1).toUpperCase()
}

export function generateDefaultAvatar (name) {
  const seed = String(name || '').trim() || 'user'
  const initial = avatarInitial(name)
  const palette = AVATAR_PALETTES[hashSeed(seed) % AVATAR_PALETTES.length]
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96"><defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stop-color="${palette[0]}"/><stop offset="100%" stop-color="${palette[1]}"/></linearGradient></defs><rect width="96" height="96" rx="24" fill="url(#g)"/><text x="50%" y="54%" text-anchor="middle" dominant-baseline="middle" font-size="44" font-weight="700" font-family="Arial,'PingFang SC','Microsoft YaHei',sans-serif" fill="#fff">${initial}</text></svg>`
  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`
}

export function resolveAvatar (avatar, name) {
  const src = String(avatar || '').trim()
  if (src) return src
  return generateDefaultAvatar(name)
}
